{
  "my_calendar": {
    "upcoming": "À venir",
    "recent": "Récent",
    "calendar": "Calendrier",
    "list": "Liste",
    "with": "Avec",
    "edit_key_activity": "Modifier l'activité clé",
    "mark_as_bd_activity": "Marquer comme activité de développement commercial"
  }
}
